import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  ...props
}) => {
  // raio 4px, não cápsula — a geometria angular da marca (v1.5, seção 05) contradiz botão totalmente arredondado.
  const baseStyles =
    'font-semibold rounded transition-all duration-300 focus-visible:ring-2 focus-visible:ring-rn-orange-text focus-visible:ring-offset-2';

  const variants = {
    // Botão primário: fundo laranja + texto navy, nunca texto branco (branco sobre laranja é só 3,39:1, reprova em botão).
    primary: 'bg-rn-orange hover:bg-rn-orange-hover text-rn-navy',
    // Secundário sobre fundo claro: borda e texto navy.
    secondary: 'bg-transparent text-rn-navy border border-rn-navy hover:bg-rn-navy hover:text-white',
    // "outline" é a variante secundária sobre fundo navy (footer, hero): borda #7B93AC, texto branco.
    outline: 'on-navy bg-transparent border-2 border-[#7B93AC] text-white hover:bg-white/10 focus-visible:ring-rn-orange-light',
  };

  const sizes = {
    sm: 'py-2 px-4 text-sm',
    md: 'py-3 px-8',
    lg: 'py-4 px-10 text-lg',
  };

  // As classes de estado desabilitado substituem as de variante em vez de somar
  // a elas. Somar nao funcionaria: 'hover:scale-100' e 'hover:scale-105' geram
  // regras de mesma especificidade, e quem vence e a ordem no CSS do Tailwind,
  // nao a ordem no atributo class.
  const estadoClasses = disabled
    ? 'bg-gray-200 text-gray-500 border border-gray-300 cursor-not-allowed shadow-none'
    : `${variants[variant]} shadow-md transform hover:scale-105`;

  return (
    <button
      disabled={disabled}
      className={`${baseStyles} ${estadoClasses} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
